/**
 * Whether the microphone a recording was started on is still enumerable.
 *
 * `deviceId` is `null` when the browser did not expose one for the active
 * track (Firefox omits it from `getSettings()`); the check then degrades to
 * "present" rather than raising a false alarm — silence detection remains
 * the safety net in that case.
 */
export const isCurrentDevicePresent = (
  devices: MediaDeviceInfo[],
  deviceId: string | null,
): boolean => {
  if (deviceId === null || deviceId === '') {
    return true;
  }

  return devices.some(
    (device) => device.kind === 'audioinput' && device.deviceId === deviceId,
  );
};
